import { useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import NewsPage from "../news/NewsPage";
import { CATEGORY_ITEMS } from "../../constants/categories";

const Category = () => {
  const { slug } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const stateQuery = searchParams.get("state") || undefined;

  const categoryItem = useMemo(
    () => CATEGORY_ITEMS.find((item) => item.slug === slug),
    [slug]
  );

  const includeEmptyCategory = categoryItem?.slug === "general";

  return (
    <NewsPage
      category={categoryItem?.category || slug}
      categoryAliases={categoryItem?.aliases || []}
      includeEmptyCategory={includeEmptyCategory}
      state={stateQuery}
    />
  );
};

export default Category;
